<template>
  <div class="content">
    <el-backtop></el-backtop>
    <div>
      <!-- 导航栏部分 -->
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" :router="true">
        <el-menu-item index="/mobileWorkplace">工作台</el-menu-item>
        <el-submenu index="2">
          <template slot="title">流程中心</template>
          <el-menu-item index="/myWork">我的待办</el-menu-item>
          <el-menu-item index="/flow?type=2">我发起的</el-menu-item>
          <el-menu-item index="/flow?type=3">我处理的</el-menu-item>
          <el-menu-item index="/flow?type=4">抄送我的</el-menu-item>
        </el-submenu>
        <el-menu-item index="3" disabled>|</el-menu-item>
        <el-menu-item index="/createFlow">发起新流程</el-menu-item>
      </el-menu>

      <div class="main">
        <div class="title">文件拷贝</div>
        <el-divider></el-divider>
        <div class="item_all" v-if="flowList && flowList.length > 0">
          <template v-for="item in flowList">
            <div
              class="item_item"
              :key="item.id"
              v-if="item.number != '自动拷贝申请流程（内拷外）' && item.number != '法报资料申请表（内拷外）'"
              :style="randomRgb(item)"
              @click="gotoPage(item)"
            >
              <div class="form_name">{{ item.name }}</div>
              <el-divider style="margin: 16px 0"></el-divider>
              <div class="item_item_bottom"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/workbenchApi'
export default {
  data() {
    return {
      input: '',
      flowList: [],
      activeIndex: this.$route.path,
    }
  },
  mounted() {
    this.getFlow()
  },
  methods: {
    getFlow() {
      let param = { appID: '90004' } //固定写死
      api
        .listAppDetailTreeByAppID(param)
        .then((res) => {
          if (res.success) {
            this.flowList = res.data || []
            console.info(this.flowList)
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('请求失败！')
        })
    },
    gotoPage(appDetail) {
      // this.$router.push({
      //   path: appDetail.sysFunTransactionURL
      // });
      let url = '/ddFlow?funCode=' + appDetail.sysFunTransactionID
      this.$router.push({
        path: url,
      })
      // window.location.href = appDetail.sysFunTransactionURL;
      // window.location.reload(true);
    },
    randomRgb(item) {
      let R = Math.floor(Math.random() * 130 + 110)
      let G = Math.floor(Math.random() * 130 + 70)
      let B = Math.floor(Math.random() * 130 + 110)
      return {
        'border-top-color': 'rgb(' + R + ',' + G + ',' + B + ')',
      }
    },
  },
}
</script>
<style scoped>
@media screen and (min-width: 768px) {
  .item_item {
    width: 185px;
    border-top: 6px solid;
    padding-top: 16px;
    border-radius: 5px;
    background-color: #fff;
    display: inline-block;
    margin-right: 10px;
    margin-right: 20px;
    vertical-align: top;
    margin-bottom: 20px;
    box-shadow: 2px 2px 10px #e4ebf3;
    cursor: pointer;
  }
}
.workplace_nav {
  height: 60px;
  position: fixed;
  width: 100%;
  z-index: 1;
}
img.nav_img {
  width: 30px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  border-radius: 25px;
  vertical-align: middle;
  /* margin-left: 9px; */
}
.bread {
  display: inline-block;
  font-size: 16px;
}

.main {
  padding: 20px;
  text-align: center;
  max-width: 1000px;
  margin: auto;
}
.title {
  text-align: left;
  font-size: 16px;
}

.item_item_bottom {
  margin-top: -20px;
  color: #007effd9;
  text-align: right;
  margin-right: 5px;
  background-color: #fff;
  padding-bottom: 10px;
}
span.flow {
  font-size: 12px;
  display: inline-block;
  margin-right: 5px;
}
span.right {
  font-size: 20px;
  display: inline-block;
  vertical-align: bottom;
  height: 23px;
}
.form_name {
  font-size: 15px;
  padding-left: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}
.item_all {
  text-align: left;
}
::v-deep .el-card__body {
  padding: 20px;
  display: flex;
  align-items: center;
}
::v-deep .el-menu.el-menu--horizontal {
  border-bottom: none;
}
::v-deep.el-card.is-always-shadow {
  -webkit-box-shadow: 0 0 0 0 #fff;
  box-shadow: 0 0 0 0 #fff;
}
@media screen and (max-width: 768px) {
  .item_item {
    width: 140px;
    border-top: 6px solid;
    padding-top: 6px;
    border-radius: 5px;
    background-color: #fff;
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 10px;
    vertical-align: top;
    box-shadow: 2px 2px 10px #e4ebf3;
    cursor: pointer;
  }
  .item {
    padding-left: 5px;
  }
}
</style>
